import React, {useRef, useImperativeHandle, forwardRef} from 'react'
import {Colors, Popup} from '@components/UI/index.js'
import {Reseller} from 'server/functions/resellers/resellers.types'
import {Shift} from 'types/types.js'
import type {PopupRef} from '../../src/components/UI/overlays/Popup.js'

type ShiftActivityPopupProps = {
    reseller: Reseller
}

type ShiftActivityPopupRef = {
    open: (shift: Shift) => Promise<string | undefined>
    close: () => Promise<void>
}

const ShiftActivityPopup = forwardRef((props: ShiftActivityPopupProps, ref: React.RefObject<ShiftActivityPopupRef>) => {
    const popupRef = useRef<PopupRef>(null)
    const {reseller} = props

    const open = async (shift: Shift) => {
        const currentActivity = shift && reseller.settings.shifts?.activities?.find((activity) => activity.id === shift.activityId)

        let lastAutomaticActivityId: string | undefined = undefined

        if (!currentActivity?.automaticOnly) {
            lastAutomaticActivityId = shift.history?.findLast((entry) => {
                if (entry.type === 'startActivity' && entry.activityId && entry.activityId !== shift.activityId) {
                    const activity = reseller.settings.shifts?.activities?.find((activity) => activity.id === entry.activityId)

                    return activity?.automaticOnly
                }
            })?.activityId
        }

        const option = await popupRef.current.openOptions('Kies activiteit', '', reseller.settings.shifts.activities.filter((activity) => (activity.id !== shift.activityId && (!activity.automaticOnly || lastAutomaticActivityId === activity.id))).map((activity) => ({
            title: activity.name,
            value: activity.id,
            wrapperStyle: {background: activity.color, borderRadius: 12, marginBottom: 6},
            style: {color: Colors.isDarkBackground(activity.color) ? Colors.white : Colors.textDark}
        })))

        return option?.value
    }

    useImperativeHandle(ref, () => ({
        open,
        close: popupRef.current.close
    }))

    return (
        <Popup ref={popupRef} closeButton={true} />
    )
})

ShiftActivityPopup.displayName = 'ShiftActivityPopup'

export default ShiftActivityPopup
